/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'angular2-image-zoom/src/image-zoom-lens.component';
const styles_ImageZoomLens:any[] = ['[_nghost-%COMP%] {\n            float: right;\n            overflow: hidden;\n            z-index: 999;\n            opacity: .4;\n            zoom: 1;\n            cursor: default;\n            border: 1px solid rgb(0, 0, 0);\n            position: absolute;\n            background: rgb(255, 255, 255) no-repeat 0 0;\n            pointer-events: none;\n        }'];
export const RenderType_ImageZoomLens:i0.RendererType2 = i0.ɵcrt({encapsulation:0,
    styles:styles_ImageZoomLens,data:{}});
export function View_ImageZoomLens_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
export function View_ImageZoomLens_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'image-zoom-lens',
      ([] as any[]),(null as any),[[(null as any),'mousemove'],[(null as any),'mouseleave'],
          [(null as any),'MozMousePixelScroll'],[(null as any),'DOMMouseScroll'],[(null as any),
              'mousewheel']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('mousemove' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onMousemove($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,1).onMouseleave($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('MozMousePixelScroll' === en)) {
          const pd_2:any = ((<any>i0.ɵnov(_v,1).onMouseScroll($event)) !== false);
          ad = (pd_2 && ad);
        }
        if (('DOMMouseScroll' === en)) {
          const pd_3:any = ((<any>i0.ɵnov(_v,1).onMouseScroll($event)) !== false);
          ad = (pd_3 && ad);
        }
        if (('mousewheel' === en)) {
          const pd_4:any = ((<any>i0.ɵnov(_v,1).onMouseScroll($event)) !== false);
          ad = (pd_4 && ad);
        }
        return ad;
      },View_ImageZoomLens_0,RenderType_ImageZoomLens)),i0.ɵdid(1,49152,(null as any),
      0,i1.ImageZoomLens,[i0.ElementRef],(null as any),(null as any))],(null as any),
      (null as any));
}
export const ImageZoomLensNgFactory:i0.ComponentFactory<i1.ImageZoomLens> = i0.ɵccf('image-zoom-lens',
    i1.ImageZoomLens,View_ImageZoomLens_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvQXN5bHVtL2lkZW50aXR5LXZhZ3JhbnQvc3JjL2FzeWx1bS1pZGVuZXRpdHkvbm9kZV9tb2R1bGVzL2FuZ3VsYXIyLWltYWdlLXpvb20vc3JjL2ltYWdlLXpvb20tbGVucy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vQzovVXNlcnMvQXN5bHVtL2lkZW50aXR5LXZhZ3JhbnQvc3JjL2FzeWx1bS1pZGVuZXRpdHkvbm9kZV9tb2R1bGVzL2FuZ3VsYXIyLWltYWdlLXpvb20vc3JjL2ltYWdlLXpvb20tbGVucy5jb21wb25lbnQuZC50cyIsIm5nOi8vL0M6L1VzZXJzL0FzeWx1bS9pZGVudGl0eS12YWdyYW50L3NyYy9hc3lsdW0taWRlbmV0aXR5L25vZGVfbW9kdWxlcy9hbmd1bGFyMi1pbWFnZS16b29tL3NyYy9pbWFnZS16b29tLWxlbnMuY29tcG9uZW50LmQudHMuSW1hZ2Vab29tTGVuc19Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxpbWFnZS16b29tLWxlbnM+PC9pbWFnZS16b29tLWxlbnM+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtVQUFBO2NBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBLHlEQUFBO01BQUE7Ozs7In0=



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/aot/node_modules/angular2-image-zoom/src/image-zoom-lens.component.ngfactory.ts